import lodash from 'lodash';

export default function filter (params) {
  const pureParams = lodash.cloneDeep(params);
  if (typeof pureParams !== 'object') return {};
  Object.keys(pureParams).forEach(key => {
    if (pureParams[key] === '' || pureParams[key] === null) {
      delete pureParams[key];
    }
  });
  return pureParams;
}



// WEBPACK FOOTER //
// ./src/utils/filter.js